import $ from "jquery";
// NOTE: window.jQuery を jquery-ui 等のレガシーライブラリより先に設定するための専用モジュール
// esbuild は import をホイストするため、このファイルを jquery-ui の import より先に置くことで
// jquery-ui の UMD factory 実行時に window.jQuery が参照できるようにする
window.jQuery = $;
window.$ = $;
